module.exports = __webpack_public_path__ + "1.5.0-unryo/img/cisco.73e741f3.svg";